import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import MailboxTable from '@communications/components/tables/mailbox-table/mailbox-table.vue';

@Component({
  name: 'bpc-mailbox',
  components: {
    'bpc-mailbox-table': MailboxTable,
  },
})
export default class Mailbox extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
